module.exports = new __parcel__URL__("intro-to-ghg-center--cover.b0e19b27.jpg").toString();